module.exports = __webpack_public_path__ + "media/more_info/face-db6412b4.svg";